import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyExtension, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
    selector: 'app-object',
    templateUrl: './object.component.html',
    styleUrls: ['./object.component.scss'],
    standalone: false
})
export class ObjectComponent extends FieldType<FieldTypeConfig> implements FormlyExtension {

    prePopulate(field: this['field']) : void {
        if (field.key && !field.fieldGroup?.length) {
            field.fieldGroup = [
                {
                    key: 'yamlObjectReplace',
                    type: 'yaml',
                    templateOptions: {
                        hideLabel: 'true',
                    },
                },
            ];
        }
    }

    isOneOfTheChildrenRequired(field: FormlyFieldConfig) {
        // expand the panel for fields where one of the children is required or has a value
        let result = false;
        if (
            !field.parent?.key ||
			!!field.templateOptions.required ||
			(field.type !== 'object' && field.formControl.value)
        ) {
            result = true;
        } else if (field.fieldGroup?.length > 0) {
            field.fieldGroup.forEach((item) => {
                result = this.isOneOfTheChildrenRequired(item);
            });
        }
        return result;
    }
}
